import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

export type GetOldCatalogProgressCatalogInfoResponce = {
  "OrderCode": string,
  "CatalogId": string,
}

/**
 * 企画進捗管理最古企画情報取得
 * 
 * 企画進捗管理テーブルの一番古い企画回情報を取得する。
 */
@Injectable()
export class GetOldCatalogProgressCatalogInfo extends PlessJsonResponderSub<GetOldCatalogProgressCatalogInfoResponce> {
  execute(s: (data: any) => void = () => {}) {
    this.success = s;
    this.send('getOldCatalogProgressCatalogInfo', new PlessRequest());
  }

  success(data: any): void {
    if (data) this.success(data);
  }
}